/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { Container } from '@adobe-commerce/elsie/lib';
import { ResetPasswordForm } from '@/auth/components';
import { ResetPasswordProps } from '@/auth/types';

export const ResetPassword: Container<ResetPasswordProps> = ({
  slots,
  formSize,
  routeSignIn,
  onErrorCallback,
  onSuccessCallback,
}) => {
  return (
    <div className="auth-reset-password">
      <ResetPasswordForm
        slots={slots}
        formSize={formSize}
        routeSignIn={routeSignIn}
        onErrorCallback={onErrorCallback}
        onSuccessCallback={onSuccessCallback}
      />
    </div>
  );
};
